import { render, staticRenderFns } from "./TheContactButton.vue?vue&type=template&id=18145fe6&"
import script from "./TheContactButton.vue?vue&type=script&lang=js&"
export * from "./TheContactButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports